import { combineReducers } from "redux";
import GeneralReducer from "./GeneralReducer";
import LoginReducer from "./LoginReducer";
import ScheduleBuilderReducer from "./ScheduleBuilderReducer";
import ReservationReducer from "./ReservationReducer";
import HotelReducer from "./HotelReducer";
import UserReducer from "./UserReducer";
import VenuesReducer from "./VenuesReducer";

export default combineReducers({
  generalReducer: GeneralReducer,
  loginReducer: LoginReducer,
  scheduleBuilderReducer: ScheduleBuilderReducer,
  reservationReducer: ReservationReducer,
  usersReducer: UserReducer,
  hotelsReducer: HotelReducer,
  venuesReducer: VenuesReducer
});
